import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn } from '@angular/router';
import { filter, map, take } from 'rxjs';
import { UserContextService } from '../services';

export const userContextReadyGuard: CanActivateFn = () => {
  const contextService = inject(UserContextService);

  return toObservable(contextService.isInitialized).pipe(
    filter((isReady) => isReady),
    take(1),
    map(() => true),
  );
};
